export default __webpack_public_path__ + "static/media/bootstrap.0b06bcc0.jpg";